module.exports = __webpack_public_path__ + "img/success.319616af.png";